// @flow

import React from 'react'
import Select from 'react-select'
import bindAll from 'lodash/bindAll'
import Header from '../partials/Header.jsx'
import Footer from '../partials/Footer.jsx'
import imgHelper from '../../images/public/helper.svg'
import imgFAQ from '../../images/public/faq.svg'
import imgHow from '../../images/public/how-to-use.svg'
import imgContact from '../../images/public/contact-us.svg'
import { Link } from 'react-router-dom'

type Props = {};

type State = {
	searchValue: string
};

class HelpPage extends React.Component<Props, State> {
	constructor() {
		super()

		this.state = {
			searchValue: ''
		}

		bindAll(this, [
			'handleSearchChange'
		])
	}

	componentDidMount() {
		window.scrollTo(0, 0)
	}

	handleSearchChange(e: Object) {
		this.setState({searchValue: e.value})

		window.location.href = `/help/faq#${e.value}`
	}

  render() {
  	const faqOptions: Array<Object> = [
			{value: 'faq-what-is-astronaut', label: 'What is Astronaut (and what is it not?)'},
			{value: 'faq-interview-feature', label: 'Does Astronaut have a live video interview feature?'},
			{value: 'faq-why-video', label: 'Why video?'},
			{value: 'faq-anti-fraud', label: 'How to overcome candidates for cheating?'},
			{value: 'faq-how-to-answer', label: 'How do candidates answer the questions?'},
			{value: 'faq-likes-astronaut', label: 'Do candidates like the experience of using Astronaut?'},
			{value: 'faq-screening-time', label: 'Can I use Astronaut for screening 1000s candidates in only a few days?'},
			{value: 'faq-internet-connection', label: 'What if the internet connection is not very good? What is the candidate participation rate? '},
			{value: 'faq-contact-us', label: 'If candidates have questions about Astronaut, who should they contact?'},
			{value: 'htu-getting-started', label: 'Getting started'},
			{value: 'htu-create-jobs', label: 'Create jobs'},
			{value: 'htu-candidates', label: 'Candidates'},
			{value: 'htu-question-page', label: 'Question Page'},
			{value: 'htu-sending-invites', label: 'Sending Invites'},
			{value: 'htu-filtering-candidate', label: 'Filtering candidate'},
			{value: 'htu-reports', label: 'Reports'},
			{value: 'htu-hiring-team-collaboration', label: 'Hiring team collaboration'}
		]

    return (
			<main>
				<section className="homepage-feature">
	        <Header isNavbarFixed={false} />
	        <div className="homepage-feature--search">
	          <div className="container">
	            <div className="jumbotron">
	              <div className="row">
	                <div className="col-sm-6 col-xs-12">
	                  <h1>Astronaut Help Center</h1>
	                  <form className="p-t-24">
	                    <div className="form-group">
	                      <label htmlFor="search">How can we help?</label>
												<div className="search full-width">
													<Select
														className="search-form hide-options"
														id="search-username"
														value={this.state.searchValue}
														onChange={this.handleSearchChange}
														options={faqOptions}
														placeholder="Type to search..."
														clearable={false}
														isSearchable={true} />
												</div>
	                    </div>
	                  </form>
	                </div>
	                <div className="col-sm-6 mobile">
	                  <div className="vertical-item--center flex-end">
	                    <img className="img-responsive" src={imgHelper} alt="Help Desk" />
	                  </div>
	                </div>
	              </div>
	            </div>
	          </div>
	        </div>
	      </section>
				<section>
					<div className="container">
						<div className="row">
							<div className="col-md-4">
								<div className="panel">
									<div className="panel-body shadow">
										<div className="feature-img">
											<img src={imgFAQ} alt="FAQ" />
										</div>
										<div>
											<h3 className="heading3 m-t-15">Frequently Asked Questions </h3>
											<p className="heading5 normal">Find the answers to the most commonly asked questions about our recruiter experience.<br /><br />
											<Link to={`/help/faq/#faq-content`} className="text-body underline">Learn More <i className="glyphicon glyphicon-chevron-right"></i></Link></p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4">
								<div className="panel">
									<div className="panel-body shadow">
										<div className="feature-img">
											<img src={imgHow} alt="How to use" />
										</div>
										<div>
											<h3 className="heading3 m-t-15">How to use product</h3>
											<p className="heading5 normal">Learn the basics of navigating around the recruiter dashboard and using the features. <br /><br />
											<Link to={`/help/faq/#htu-content`} className="text-body underline">Start <i className="glyphicon glyphicon-chevron-right"></i></Link></p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4">
								<div className="panel">
									<div className="panel-body shadow">
										<div className="feature-img">
											<img src={imgContact} alt="Envelope" />
										</div>
										<div>
											<h3 className="heading3 m-t-15">Contact us</h3>
											<p className="heading5 normal">if you dont have what you need? Contact us to : <br /><br /><br />
											<a href="mailto:support@astrnt.co" className="text-body underline">support@astrnt.co</a></p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				<Footer />
			</main>
		)
  }
}

export default HelpPage
